export const SERVICE_KEYS = {
  API_INSTANCE: Symbol.for('API_INSTANCE'),
  DASHBOARD_REPOSITORY: Symbol.for('DASHBOARD_REPOSITORY'),
  AUTH_REPOSITORY: Symbol.for('AUTH_REPOSITORY'),
  USER_REPOSITORY: Symbol.for('USER_REPOSITORY'),
  CONTRACT_REPOSITORY: Symbol.for('CONTRACT_REPOSITORY'),
  PARAMETER_REPOSITORY: Symbol.for('PARAMETER_REPOSITORY'),
};
